import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import CreateMatchForm from "@/components/CreateMatchForm";

/**
 * Dedicated full page for creating a match. Replaces the modal flow when coming
 * from the map (FindMatchPage) to avoid stacking/perf conflicts. The selected
 * terrain is passed via the `?terrain=` query param and hydrates the "Lieu" field.
 */
export default function CreateMatchPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const terrain = params.get("terrain") || "";

  const handleCreated = (match) => {
    // Let the rest of the app refresh its match lists.
    window.dispatchEvent(new Event("matchup:match-created"));
    if (match?.id) {
      navigate(`/match/${match.id}`);
    } else {
      navigate("/matches");
    }
  };

  return (
    <div
      data-testid="create-match-page"
      style={{ minHeight: "100dvh", backgroundColor: "#000", display: "flex", flexDirection: "column" }}
    >
      <header
        style={{
          padding: "14px 16px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          backgroundColor: "rgba(0,0,0,0.95)",
          borderBottom: "1px solid #1a1a1a",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <button
          data-testid="create-match-back-btn"
          onClick={() => navigate(-1)}
          style={{ padding: "8px", background: "none", border: "none", color: "#fff", cursor: "pointer" }}
        >
          <ArrowLeft size={22} />
        </button>
        <h1
          className="font-heading italic uppercase font-black tracking-wide"
          style={{ flex: 1, fontSize: "20px", color: "#fff", margin: 0 }}
        >
          Créer un match
        </h1>
      </header>

      <div style={{ flex: 1, width: "100%", maxWidth: "440px", margin: "0 auto" }}>
        <CreateMatchForm initialLocation={terrain} onCreated={handleCreated} />
      </div>
    </div>
  );
}
